/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 데스크탑 요소 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/components/Desktop.ts
 * @author sungjin <esung246@naddle.net>
 * @license MIT License
 * @modified 2025. 9. 9.
 */
import { Panel } from '@components/desktop/Panel';

export const Desktop = { Panel };
